import React, { useEffect, useState } from 'react';
import styles from "./orderdetails.module.css"
import { Box, CircularProgress, Step, StepConnector, StepLabel, Stepper, Typography, useMediaQuery, useTheme } from '@mui/material';
import ReviewPopup from '../../components/reviewpopup/ReviewPopup';
import Myprofile from '../myprofile/Myprofile';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderDetailsThunk, setOrderRefresh } from '../../../redux/orderSlice';
import { formatedate, formatedateTime } from '../../../helper/utils';
import api from '../../../helper/Api';
import Toastify from '../../../helper/Toastify';
import { styled } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";

// Custom Connector
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    "&.MuiStepConnector-root": {
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)",
        [theme.breakpoints.down("sm")]: {
            top: 12,
            left: "calc(-50% + 16px)",
            right: "calc(50% + 16px)",
        },
    },
    "& .MuiStepConnector-line": {
        borderTopWidth: 4,
        borderColor: "#000",
        marginTop: "6px",
        [theme.breakpoints.down("sm")]: {
            borderTopWidth: 4,
            borderColor: "#000 !important", // or "#000" or with !important if needed
        },
    },
}));




// Custom Step Icon
const CustomStepIcon = ({ active, completed, icon }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <div
            style={{
                width: isMobile ? 28 : 40,
                height: isMobile ? 28 : 40,
                borderRadius: "50%",
                backgroundColor: completed ? "green" : "black",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: isMobile ? 12 : 16,
                fontWeight: "bold",
            }}
        >
            {completed ? <CheckIcon fontSize={isMobile ? "small" : "medium"} /> : icon}
        </div>
    );
};

const OrderDetails = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // screens <600px
    const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
    const [isPopupVisible, setIsPopupVisible] = useState(false); // Popup hidden initially
    const { orderDetails, isLoading, isRefresh } = useSelector(state => state.orders)
    const orderData = orderDetails?.data
    console.log('orderdata================', orderData);

    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [selectedProduct, setSelectedProduct] = useState(null)

    const totalPriceAfterDiscount = orderData?.total + orderData?.discount;

    const handleSignupClick = (product) => {
        setSelectedProduct(product)
        setIsPopupVisible(true);
    };

    useEffect(() => {
        dispatch(getOrderDetailsThunk(id))
    }, [isRefresh, id, dispatch])


    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20 }}>
                <CircularProgress />
            </div>
        )
    }


    const handleRazorpayPayment = async (pendingamount) => {
        try {

            const paymentResponse = await api.paymentStepOne({
                grandTotal: pendingamount,
                currency: 'INR',
            });
            const { order } = paymentResponse.data.data;
            if (orderData?.isMutlipleOrder === false) {
                const options = {
                    key: "rzp_live_0sPo86UGWBLY0z",
                    amount: order.amount,
                    currency: 'INR',
                    order_id: order.id,
                    handler: async function (response) {
                        const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

                        const apiResSinlge = await api.payRemainingprice({
                            razorpay_payment_id,
                            razorpay_order_id,
                            razorpay_signature,
                            id
                        });

                        if (apiResSinlge?.data?.success) {
                            const orderId = orderData?.hdfc_order_id || orderData?._id;
                            navigate(`/thankyouPopup?order_id=${orderId}`);
                        } else {
                            const reason = apiResSinlge?.data?.message || 'Unknown error';
                            navigate(`/paymentFailed?reason=${encodeURIComponent(reason)}`);
                        }
                        dispatch(setOrderRefresh())
                    },
                };

                // Open Razorpay payment gateway
                const razorpay = new window.Razorpay(options);

                razorpay.on("payment.failed", () => {
                    navigate(`/paymentFailed`);
                });

                razorpay.open();
            } else if (orderData?.isMutlipleOrder === true) {
                const options = {
                    key: "rzp_live_0sPo86UGWBLY0z",
                    amount: order.amount,
                    currency: 'INR',
                    order_id: order.id,
                    handler: async function (response) {
                        const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;

                        const apiResMultiple = await api.payRemainingpriceForMultiplleProduct({
                            razorpay_payment_id,
                            razorpay_order_id,
                            razorpay_signature,
                            id
                        });

                        if (apiResMultiple?.data?.success) {
                            const orderId = orderData?.hdfc_order_id || orderData?._id;
                            navigate(`/thankyouPopup?order_id=${orderId}`);
                        } else {
                            const reason = apiResMultiple?.data?.message || 'Unknown error';
                            navigate(`/paymentFailed?reason=${encodeURIComponent(reason)}`);
                        }
                        dispatch(setOrderRefresh());
                    },
                };

                // Open Razorpay payment gateway
                const razorpay = new window.Razorpay(options);

                razorpay.on("payment.failed", () => {
                    navigate(`/paymentFailed`);
                });

                razorpay.open();
            }
        } catch (error) {
            console.error("Payment error:", error);
            navigate(`/paymentFailed`);
        }
    };

    const payPendingAmountHDFC = async (pendingamount) => {
        try {

            const paymentResponse = await api.payPendingAmountHdfc({
                amount: pendingamount,
                originalOrderId: orderData?.hdfc_order_id,
            });
            const { paymentUrl, order } = paymentResponse.data;
            console.log('paymentResponse.data.data', paymentResponse.data);

            // 🔁 Redirect to HDFC payment gateway
            if (paymentUrl) {
                window.location.href = paymentUrl;
            } else {
                Toastify.error("Payment URL not found.");
            }
            const options = {
                amount: order.sdk_payload.payload.amount,
                currency: 'INR',
                order_id: order.order_id
            };
        } catch (error) {
            console.error("Payment error:", error);
            Toastify.error("Payment failed, please try again.");
        }
    };

    const steps = [
        { label: "Order received", status: "NEW" },
        { label: "Processing", status: "PROCESSING" },
        { label: "Shipped", status: "SHIPPED" },
        { label: "Delivered", status: "DELIVERED" }
    ];


    const totalAdvancePayment = orderData?.products?.reduce((sum, item) => sum + (item.adPaymentAmount || 0), 0)
    const totalPendingAmount = orderData?.products?.reduce((sum, item) => sum + (item.pendingAmount || 0), 0)



    return (
        <>
            <Myprofile >

                <div className={styles.ordetailsContainer}>
                    <div className={styles.ordetailsheader}>
                        <div className={styles.ordetails_status}>
                            <h2>Order Details</h2>
                            <div className={styles.status}>
                                &nbsp;{formatedate(orderData?.updatedAt)}&nbsp; &nbsp;
                                {orderData?.products?.length} {orderData?.products?.length === 1 ? 'Product' : 'Products'}
                            </div>
                        </div>
                        <button className={styles.editButton} onClick={() => navigate(-1)} >
                            Back to List
                        </button>
                    </div>


                    <div className={styles.profilebodyContent}>
                        {orderData?.products?.map((product, index) => {
                            const arr = product?.status;
                            const lastValue = arr?.at(-1);
                            return (
                                <>
                                    <div className={styles.container} style={{ cursor: "pointer" }} onClick={() => navigate(`/prodDescription/${product.productId?._id}`)}>
                                        <div style={{
                                            display: 'flex', gap: '20px', alignItems: 'center',
                                        }}>
                                            <img
                                                src={product?.productId?.featurerdImage}
                                                className={styles.productImage}
                                                alt='featuredImage'
                                            />
                                            <div style={{
                                                display: 'flex', gap: '10px',
                                                alignItems: 'flex-start',
                                                flexDirection: 'column'
                                            }}>
                                                <div className={styles.orderTypeStyle}>{product?.orderType}
                                                </div>
                                                <Box>
                                                    <p className={styles.productNameText}>
                                                        {product?.productId?.productName}
                                                    </p>
                                                    <Box sx={{ display: 'flex', gap: '8px', marginTop: '5px' }}>
                                                        <p className={styles.sellingPriceText}>
                                                            ₹ {product?.sellingPrice?.toLocaleString("en-IN")}
                                                        </p>
                                                        {product?.discount === 0 ? (
                                                            null
                                                        ) : (
                                                            <p
                                                                style={{
                                                                    textDecoration: 'line-through', color: 'gray',
                                                                    fontSize: '14px',
                                                                    fontFamily: 'karla'
                                                                }}
                                                            >
                                                                ₹ {product?.totalPrice?.toLocaleString("en-IN")}
                                                            </p>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </div>
                                        </div>

                                        <div style={{
                                            display: 'flex', gap: '10px',
                                            alignItems: 'flex-start',
                                            justifyContent: 'space-around',
                                            flexDirection: 'column'
                                        }}>
                                            <p className={styles.orderStatusText}>
                                                {lastValue?.name === 'NEW' ? 'New'
                                                    : lastValue?.name === 'PROCESSING' ? 'Processing'
                                                        : lastValue?.name === 'SHIPPED' ? 'Out for delivery'
                                                            : 'Delivered'} on {formatedate(lastValue?.date)}
                                            </p>
                                            {lastValue?.name === 'DELIVERED' && (
                                                <button style={{
                                                    color: '#FE671F',
                                                    fontSize: '16px',
                                                    textDecoration: "underline",
                                                    fontFamily: 'karla'
                                                }} onClick={() => handleSignupClick(product)}>
                                                    Write a review
                                                </button>
                                            )}
                                        </div>
                                    </div>
                             
                                    <div className={styles.ordetailsbody}>
                                        <div className={styles.progress_container}>
                                            <Stepper
                                                alternativeLabel={isDesktop}
                                                orientation={isMobile ? "vertical" : "horizontal"}
                                                activeStep={product?.status?.length - 1}
                                                connector={<CustomConnector />}
                                                sx={{ width: "100%" }}
                                            >
                                                {product?.status?.map((step, index) => {
                                                    const isCompleted = index <= product?.status?.length - 1;

                                                    return (
                                                        <Step key={step._id} completed={isCompleted}>
                                                            <StepLabel StepIconComponent={CustomStepIcon}
                                                                sx={{
                                                                    padding: '0px !important'

                                                                }}
                                                            >
                                                                <div style={{ textAlign: isMobile ? "left" : "center" }}>
                                                                    <p style={{
                                                                        margin: 0,
                                                                        fontWeight: 400,
                                                                        fontFamily: 'Karla',
                                                                        fontSize: isMobile ? 12 : 14,
                                                                        color: '#000000'
                                                                    }}>
                                                                        {
                                                                            step.name === "NEW" ? 'Order received' :
                                                                                step.name === "PROCESSING" ? 'Processing' :
                                                                                    step.name === "SHIPPED" ? "Out for delivery" :
                                                                                        "Delivered"
                                                                        }
                                                                    </p>
                                                                    <small style={{
                                                                        fontWeight: 400,
                                                                        fontFamily: 'Karla',
                                                                        fontSize: isMobile ? 9 : 10,
                                                                        color: '#999999'
                                                                    }}>
                                                                        {formatedateTime(step?.date)}
                                                                    </small>
                                                                </div>
                                                            </StepLabel>
                                                        </Step>
                                                    );
                                                })}
                                            </Stepper>
                                        </div>

                                    </div>
                                </>
                            );
                        })
                        }
                    </div>
                    <div className={styles.ordetailsaddress}>
                        {/*  Billing and Shipping Addresses  */}
                        <div className={styles.address_container}>
                            <div style={{ display: 'flex', flexDirection: "column", gap: '20px' }}>
                                <div className={styles.display}>
                                    <div className={styles.address_box}>
                                        <div className={styles.h3}>Billing Address</div>
                                        <div className={styles.address_deets}>
                                            <p><strong>{orderData?.billingAddress?.firstName} {orderData?.billingAddress?.lastName ? orderData?.billingAddress?.lastName : ""}</strong></p>
                                            <p>{orderData?.billingAddress?.unit && `${orderData?.billingAddress?.unit},`} {orderData?.billingAddress?.streetAddress && `${orderData?.billingAddress?.streetAddress},`} {orderData?.billingAddress?.city && `${orderData?.billingAddress?.city},`} {orderData?.billingAddress?.state}-{orderData?.billingAddress?.pincode}</p> <br />
                                            {/* <p><strong>Email:</strong> dainne.russell@gmail.com</p> */}
                                            <p><strong>Phone: </strong>{orderData?.billingAddress?.phone}</p>
                                        </div>
                                    </div>
                                    <div className={styles.address_box}>
                                        <div className={styles.h3}>Shipping Address</div>
                                        <div className={styles.address_deets}>
                                            <p><strong>{orderData?.shippingAddress?.firstName} {orderData?.shippingAddress?.lastName ? orderData?.shippingAddress?.lastName : ""}</strong></p>
                                            <p>{orderData?.shippingAddress?.unit && `${orderData?.shippingAddress?.unit},`} {orderData?.shippingAddress?.streetAddress && `${orderData?.shippingAddress?.streetAddress},`} {orderData?.shippingAddress?.city && `${orderData?.shippingAddress?.city},`} {orderData?.shippingAddress?.state}-{orderData?.shippingAddress?.pincode}</p> <br />
                                            {/* <p><strong>Email:</strong> dainne.russell@gmail.com</p> */}
                                            <p><strong>Phone: </strong>{orderData?.shippingAddress?.phone}</p>
                                        </div>
                                    </div>
                                </div>
                                {orderData?.isMutlipleOrder === false ? (
                                    <>
                                        {orderData?.weigthStatus &&
                                            <div className={styles.rejection}>
                                                <h3 style={{ padding: "0px 20px" }}>Notes</h3>
                                                <hr style={{ background: '#E6E6E6' }} />
                                                <div className={styles.order_deets}>
                                                    <p>Weight status<strong>{orderData?.weigthStatus}</strong> </p>
                                                    <p>Weight in grams<strong>{orderData?.extraWeight}g</strong> </p>
                                                    <p>Notes<strong style={{ width: '70%', textAlign: 'right' }}>{orderData?.customerNote}</strong> </p>
                                                </div>
                                            </div>
                                        }
                                    </>
                                ) : (
                                    <>
                                        {orderData?.products.map((item) => (
                                            <>
                                                {item?.weigthStatus && (
                                                    <div className={styles.rejection}>
                                                        {/* <h3 style={{ padding: "0px 20px" }}>Notes</h3> */}
                                                        <h3 style={{ padding: "0px 20px", letterSpacing: '-0.5px' }}>Product Name : {item?.productName}</h3>
                                                        <hr style={{ background: '#E6E6E6' }} />
                                                        <div className={styles.order_deets}>
                                                            <p>Weight status<strong>{item?.weigthStatus}</strong> </p>
                                                            <p>Weight in grams<strong>{item?.extraWeight}g</strong> </p>
                                                            <p>Pending amount<strong>₹ {item?.pendingAmount?.toLocaleString("en-IN")}</strong> </p>
                                                            <p>Notes<strong style={{ width: '70%', textAlign: 'right' }}>{item?.customerNote}</strong> </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ))
                                        }
                                    </>
                                )}
                            </div>
                        </div>
                        <div className={styles.order_summary}>
                            <div className={styles.order_head}>
                                <div>Order ID: <br /><strong>#{orderData?._id}</strong> </div>
                                <div>Payment Method:<br />{orderData?.payment?.method === 'HDFC' ? (<strong>HDFC</strong>) : (<strong>razorpay</strong>)}</div>
                            </div>
                            <div className={styles.order_deets}>
                                {/* {orderData?.products?.[0]?.productId?.gold?.type === 'k22' ? (
                                                <p>Gold rate<strong>18k: ₹{orderData?.goldRate18k}/g</strong> </p>
                                            ) : (
                                                <p>Gold rate<strong>22k: ₹{orderData?.goldRate22k}/g</strong> </p>
                                            )} */}
                                <p>Total:<span className={styles.total_price}>₹ {totalPriceAfterDiscount?.toLocaleString("en-IN")}</span> </p>
                                {orderData?.discount === 0 ? (
                                    null
                                ) : (
                                    <p>Discount:<strong>₹ {orderData?.discount?.toLocaleString("en-IN")}</strong> </p>
                                )}
                                {/* <p>Subtotal:<strong>₹{orderData?.subTotal?.toLocaleString("en-IN")}</strong> </p> */}

                                {orderData?.isMutlipleOrder === false && orderData?.advancePaid !== 0 ? (
                                    <p>Advance paid<strong>₹ {orderData?.advancePaid?.toLocaleString("en-IN")}</strong> </p>
                                ) : orderData?.isMutlipleOrder === true && totalAdvancePayment !== 0 ? (
                                    <p>
                                        Advance paid: <strong>
                                            ₹ {totalAdvancePayment.toLocaleString("en-IN")}
                                        </strong>
                                    </p>
                                ) : null}
                                <p>Shipping:<strong>Free</strong> </p>
                                <hr style={{ backgroundColor: '#E6E6E6 !important' }} />
                                <p><strong>Grand Total:</strong> <span className={styles.total_price}>₹ {orderData?.grandTotal?.toLocaleString("en-IN")}</span></p>
                            </div>
                            {orderData?.isMutlipleOrder === false && orderData?.pendingAmount !== 0 ? (
                                <div className={styles.order_head} style={{ border: "1px solid #E6E6E6" }}>
                                    <div>Pending amount <br /><strong>₹ {orderData?.pendingAmount?.toLocaleString("en-IN")}</strong> </div>
                                    <div className={styles.paybox}>
                                        <strong style={{ color: "#34A853", textDecoration: "underline", fontSize: "14px", cursor: 'pointer' }} onClick={() => payPendingAmountHDFC(orderData?.pendingAmount)}>Pay with HDFC
                                        </strong>

                                        <strong style={{ color: "#34A853", textDecoration: "underline", fontSize: "14px", cursor: 'pointer' }} onClick={() => handleRazorpayPayment(orderData?.pendingAmount)}>Pay with Razorpay
                                        </strong>
                                    </div>
                                </div>
                            ) : orderData?.isMutlipleOrder === true && totalPendingAmount !== 0 ? (
                                <div className={styles.order_head} style={{ border: "1px solid #E6E6E6" }}>
                                    <div>Pending amount <br /><strong>₹ {orderData?.products?.reduce((sum, item) => sum + (item.pendingAmount || 0), 0).toLocaleString("en-IN")}</strong> </div>
                                    <div className={styles.paybox}>
                                        <div
                                            style={{ color: "#34A853", textDecoration: "underline", fontSize: "14px", cursor: 'pointer' }}
                                            onClick={() => payPendingAmountHDFC(orderData?.products?.reduce((sum, item) => sum + (item.pendingAmount || 0), 0))}>Pay with HDFC
                                        </div>

                                        <div
                                            style={{ color: "#34A853", textDecoration: "underline", fontSize: "14px", cursor: 'pointer' }}
                                            onClick={() => handleRazorpayPayment(orderData?.products?.reduce((sum, item) => sum + (item.pendingAmount || 0), 0))}>Pay With Razorpay
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </Myprofile>

            {isPopupVisible && (
                <ReviewPopup onClose={() => setIsPopupVisible(false)} selectedProduct={selectedProduct} id={id} />
            )}

        </>
    );
};

export default OrderDetails;
